import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Icon from 'components/Icon/Icon.react';
import Tooltip from 'rc-tooltip';
import LoaderDots from 'components/LoaderDots/LoaderDots.react';
import { Chart } from 'lib/charts/frappe-charts.esm.js';
import { bytesToSize, numeral } from 'lib/helpers';
import styles from './Charts.scss';


const svgMonth = (text, y) => `<text x="0" y="${y}" font-style="italic" font-size="9px" font-weigth="600" text-anchor="middle" class="rrm sashiDoTooltipTextMonth">(${text})</text>`;

export default class WorldMapBarChart extends React.Component {
  constructor(props) {
    super(props);

    this.loader = null;
    this.root = null;
    this.chart = null;

    this.formatXLabels = this.formatXLabels.bind(this);
    this.formatYLabels = this.formatYLabels.bind(this);
    this.onResize = this.onResize.bind(this);
  }

  componentDidMount() {
    this.chartBuilder(this.props);
    // window.addEventListener('resize', this.onResize);
  }

  componentWillUnmount() {
    this.chart.unbindWindowEvents();
    // window.removeEventListener('resize', this.onResize);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data && this.props.data !== nextProps.data) {
      if (this.loader) {
        this.loader.classList.add('metricsLoaderShow');
      }
      this.chartBuilder(nextProps);
    }
  }

  onResize() {
    this.loader.classList.add('metricsLoaderShow');
    this.chart.unbindWindowEvents();
    this.chartBuilder(this.props);
    setTimeout(() => {
      this.loader.classList.remove('metricsLoaderShow');
    }, 2000);
  }

  chartBuilder(props) {
    const {
      data, stacked, onSelect, dataFormat, unit,
    } = props;

    const valuesOverPoints = false;

    if (!data) {
      return null;
    }

    const tooltipOptions = {
      formatTooltipX: (d) => {
        return moment(d).format('MMM DD YYYY');
      },
      formatTooltipY: d => `${numeral(d, dataFormat)} ${unit ? `<span>${unit}</span>` : ''}`,
    };

    const barOptions = { stacked };

    this.chart = new Chart(this.root, {
      ...props, data, segmentTime: '30', dataFormat, tooltipOptions, barOptions, valuesOverPoints,
    });


    if (!this.chart && !this.parent) return;

    setTimeout(() => {
      this.formatXLabels();
      this.formatYLabels();
      setTimeout(() => {
        this.loader.classList.remove('metricsLoaderShow');
      }, 200);
    }, 2000);
  }

  formatXLabels() {
    const { billingDay, stacked } = this.props;
    const format = 'DD';

    [].forEach.call(this.parent.querySelectorAll('.rrm'), (e) => {
      e.parentNode.removeChild(e);
    });

    const labels = this.parent.getElementsByClassName('x axis')[0].getElementsByTagName('text');
    if (labels) {
      const lablesLength = labels.length;
      Array.from(labels).forEach(
        (element, index, array) => {
          const label = this.props.data.labels[index];
          const newLabel = moment(label).format(format);


          if (newLabel === '01' || index === 0) {
            const rootElement = element.parentNode;
            const month = moment(label).format('MMM');
            rootElement.insertAdjacentHTML('beforeend', `${svgMonth(month, 142)}`);
          }


          if (lablesLength > 32) {
            if (newLabel === '01' || newLabel === '15' || index === 0) {
              element.textContent = moment(label).format('DD');
            } else {
              element.textContent = '';
            }
          } else {
            element.textContent = moment(label).format('DD');
          }

          element.style.opacity = '1';
        },
      );
    }
  }

  formatYLabels() {
    const labels = this.parent.getElementsByClassName('y axis')[0].getElementsByTagName('text');
    if (labels) {
      Array.from(labels).forEach(
        (element, index, array) => {
          element.textContent = numeral(element.textContent, this.props.dataFormat);
          element.style.opacity = '1';
        },
      );
    }
  }

  handleDataSelect(event) {
    return this.props.onSelect && this.props.onSelect({
      index: event.index,
      label: event.label,
      values: event.values,
    });
  }

  render() {
    const { title } = this.props;
    return (
      <section className={[styles.graph, styles.inside, title ? styles.withTitle : ''].join(' ')}>
        <div className={[styles.g].join(' ')}>
          <div ref={parent => (this.parent = parent)} className={['charts', this.props.onSelect ? 'is_navigable' : null].join(' ')}>
            <div ref={root => (this.root = root)} />
          </div>
          <div className={styles.t}>
            {title && title}
          </div>
        </div>
        <div className={[styles.loader, styles.inside, 'metricsLoaderShow'].join(' ')} ref={r => this.loader = r}>
          <LoaderDots />
        </div>
      </section>
    );
  }
}
